var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-exclamation-circle","titulo":"ENTREGAS E DESP. VIAGENS COM ERRO NO COMPROMETIMENTO"},nativeOn:{"click":function($event){return _vm.$router.push({ name: 'Gestores_Paineis_Erros_Comprometimentos' })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }